import { useEffect } from 'react'

import { FIVE_MINUTES_IN_MS } from '~/constants'
import useGetGuestAgent from '~/features/agents/hooks/useGetGuestAgent'
import { useSetAgentId } from '~/features/agents/hooks/useSetAgentId'
import { EChatStatus } from '~/features/agents/models'
import useGetAuthSessionQuery from '~/hooks/useGetAuthSessionQuery'
import { store, sessionStore } from '~/store'

/**
 * Reset agent settings for guest users
 * If a unauthenticated user has an agent, check every 5 minutes if the chatStatus === active
 * if not, reset the agent and settings
 */
const useResetAgentForGuestUsers = () => {
  const [user, resetSettings] = store((state) => [
    state.user,
    state.resetSettings,
  ])
  const [agentId, isLoadingUser] = sessionStore((state) => [
    state.agent.id,
    state.UIElements.isLoadingUser,
  ])
  const setAgentId = useSetAgentId()

  // Guests use the dedicated /guest/agents/:agentId endpoint (useGetGuestAgent).
  const { data: agentResponse, isFetching } = useGetGuestAgent({
    agentId: !user.id && agentId ? agentId : '',
    queryOptions: { refetchInterval: FIVE_MINUTES_IN_MS },
  })

  const { data: authSession } = useGetAuthSessionQuery()
  const cognitoUid = authSession?.cognitoUid

  useEffect(() => {
    if (
      !isFetching &&
      !user.id &&
      !cognitoUid &&
      !isLoadingUser &&
      agentId &&
      agentResponse?.data?.chatStatus !== EChatStatus.active
    ) {
      resetSettings()
      setAgentId({ agentId: undefined })
    }
  }, [
    isFetching,
    agentId,
    user.id,
    cognitoUid,
    agentResponse?.data?.chatStatus,
    resetSettings,
    setAgentId,
    isLoadingUser,
  ])
}

export default useResetAgentForGuestUsers
